export const people = (state) => {
  return state.people;
};

export const team = (state) => {
  return state.people;
};
